import type { FC } from 'react';
import Dotdotdot from 'react-dotdotdot';

import { MultiLocationDisplay } from '@xing-com/crate-components-multi-location-display';
import { getTrackingUrl } from '@xing-com/crate-entity-pages-common/tracking';
import { ProfileImage } from '@xing-com/profile-image';

import type { JobCardValues } from '../../types/job-card';
import { JobsBookmarkContainer } from '../jobs-bookmark/jobs-bookmark-container';

import * as Styled from './job-card.styles';

type JobCardProps = JobCardValues & {
  onBookmarkUpdate?: () => void;
};
export const JobCard: FC<JobCardProps> = ({
  activeUntil,
  id,
  link,
  companyLogo,
  companyName,
  bookmarked,
  title,
  location,
  refreshedAt,
  onBookmarkUpdate = () => undefined,
}) => {
  const handleOnCardClick = () => {
    const trackingLink = getTrackingUrl({
      to: link,
      trackingKey: 'viewJobProfile',
    });
    window.open(trackingLink, '_blank');
  };

  return (
    <Styled.JobCard
      data-testid={`JOB-CARD-${id}`}
      key={id}
      href={link}
      onClick={(ev) => {
        ev.preventDefault();
        handleOnCardClick();
      }}
      linkProps={{
        'aria-label': 'job details link',
      }}
    >
      <Styled.CardHeader>
        {companyLogo && (
          <ProfileImage
            size="xxsmall"
            profileName={companyName}
            src={companyLogo}
            type="company"
          />
        )}
        <Styled.CompanyName size={'xsmall'}>{companyName}</Styled.CompanyName>
        <JobsBookmarkContainer
          jobId={id}
          bookmarked={bookmarked}
          onCreateBookmarkCompleted={onBookmarkUpdate}
          onDeleteBookmarkCompleted={onBookmarkUpdate}
        />
      </Styled.CardHeader>
      <Styled.Body>
        <Styled.CardTitle size="medium">
          <Dotdotdot clamp={2}>{title}</Dotdotdot>
        </Styled.CardTitle>
        <Styled.Location size="xsmall">
          <MultiLocationDisplay locations={location.cities} />
        </Styled.Location>
        <Styled.Location size="xsmall">{location.country}</Styled.Location>
      </Styled.Body>
      <Styled.Footer>
        {refreshedAt && (
          <Styled.FooterText activeUntil={activeUntil} date={refreshedAt} />
        )}
      </Styled.Footer>
    </Styled.JobCard>
  );
};
